import Model from '@/models/Model'

export default class WhWarehouse extends Model {
    
    /**
     * 
     */
    static includes = [
        "g_branch_office",
        "wh_warehouse_type",
    ]

    /**
     * 
     */
    get g_branch_office_name () {
        return this.g_branch_office.name
    }

    /**
     * 
     */
    get wh_warehouse_type_name () {
        return this.wh_warehouse_type.type
    }

    resource() {
        return "wh_warehouse"
    }

    toCreate () {
        return this.clean([
            "address",
            "description",
            "g_branch_office_id",
            "is_waste_warehouse",
            "name",
            "wh_warehouse_type_id",
        ])
    }

    toUpdate () {
        return this.clone([
            "address",
            "description",
            "g_branch_office_id",
            "id",
            "is_waste_warehouse",
            "name",
            "wh_warehouse_type_id",
        ])
    }
}